import $ from 'jquery';
import { useRef, useEffect } from 'react';
import m from "../../prime-src/prepare";
import { RecoMode } from '../types/types';

export default function ChangeStyle({styles, setStyles}) {
  m.resetStyle = function () {
    m.Cmode(m.defaultStyles.mode as RecoMode);
    m.CfontFamily(m.defaultStyles.fontFamily);
    m.CfontSize(m.defaultStyles.fontSize - styles.fontSize);
    m.ClineHeight(m.defaultStyles.lineHeight - styles.lineHeight);
    if (!m.$floating_key.is(":visible")) {
      m.toggleFK();
    }
    if (m.$recoeve_manual.is(":visible")) {
      m.$toggle_manual.trigger("click");
    }
  };
  m.Cmode = function (modeI) {
    setStyles(draft => {
      draft.mode = modeI;
      if (draft.mode === m.defaultStyles.mode) {
        m.docCookies.removeItem("styles.mode", "/", false, true);
      } else {
        m.docCookies.setItem("styles.mode", draft.mode, Infinity, "/", false, true);
      }
			return {...draft};
    });
  };
  m.CfontFamily = function (font) {
    setStyles(draft => {
      draft.fontFamily = font;
      if (draft.fontFamily === m.defaultStyles.fontFamily) {
        m.docCookies.removeItem("draft.fontFamily", "/", false, true);
      } else {
        m.docCookies.setItem("draft.fontFamily", draft.fontFamily, Infinity, "/", false, true);
      }
			return {...draft};
    });
  };
  m.CfontSize = function (increment) {
    setStyles(draft => {
      draft.fontSize += increment;
      if (draft.fontSize < 0.5) {
        draft.fontSize = 0.5;
      } else if (draft.fontSize > 3.3) {
        draft.fontSize = 3.3;
      }
      if (draft.fontSize === m.defaultStyles.fontSize) {
        m.docCookies.removeItem("styles.fontSize", "/", false, true);
      } else {
        m.docCookies.setItem("styles.fontSize", draft.fontSize.toFixed(2), Infinity, "/", false, true);
      }
			return {...draft};
    });
  };
  m.ClineHeight = function (increment) {
    setStyles(draft => {
      draft.lineHeight += increment;
      if (draft.lineHeight < 1.0) {
        draft.lineHeight = 1.0;
      } else if (draft.lineHeight > 2.5) {
        draft.lineHeight = 2.5;
      }
      if (draft.lineHeight === m.defaultStyles.lineHeight) {
        m.docCookies.removeItem("styles.lineHeight", "/", false, true);
      } else {
        m.docCookies.setItem("styles.lineHeight", draft.lineHeight, Infinity, "/", false, true);
      }
			return {...draft};
    });
  };

  function initialEffect() {
    let cookieItem;
    cookieItem = m.docCookies.getItem("styles.mode");
    if (cookieItem !== null) {
      m.Cmode(cookieItem as RecoMode);
    } else {
      m.Cmode(m.defaultStyles.mode as RecoMode);
    }

    cookieItem = m.docCookies.getItem("styles.fontFamily");
    if (cookieItem !== null) {
      m.CfontFamily(cookieItem as string);
      $(`#input-font-family`).val(m.fontFamily);
    }
    cookieItem = m.docCookies.getItem("styles.fontSize");
    if (cookieItem !== null) {
      m.CfontSize(Number(cookieItem) - m.defaultStyles.fontSize);
    }
    cookieItem = m.docCookies.getItem("styles.lineHeight");
    if (cookieItem !== null) {
      m.ClineHeight(Number(cookieItem) - m.defaultStyles.lineHeight);
    }

    m.$window.on("resize.styles", function () {
      setStyles(draft => {
        draft.innerWidth = window.innerWidth;
        draft.innerHeight = window.innerHeight;
        return {...draft};
      });
    });
  }

  useEffect(() => {
		initialEffect();
  }, []);

  return (
    <div className="side2" id="change-style">
      <form><button type="button" onClick={() => {
        m.resetStyle();
      }} style={{ width: 'auto', padding: '0 .5em' }}>Reset style</button></form>
      <form>
        <input id="button-Dark" checked={"dark" === styles.mode} type="radio" name="mode" value="Dark" onClick={() => {
          m.Cmode("dark" as RecoMode);
        }}></input>
        <label htmlFor="button-Dark" style={{ display: 'inline-block', background: 'black', color: 'white', border: '2px solid rgb(150,150,150)', padding: '0.1em 0.2em' }}>Dark</label>
        <input id="button-Bright" checked={"bright" === styles.mode} type="radio" name="mode" value="Bright" onClick={() => {
          m.Cmode("bright" as RecoMode);
        }}></input>
        <label htmlFor="button-Bright" style={{ display: 'inline-block', background: 'white', color: 'black', border: '2px solid rgb(150,150,150)', padding: '0.1em 0.2em' }}>Bright</label>
        <input id="button-Pink" checked={"pink" === styles.mode} type="radio" name="mode" value="Pink" onClick={() => {
          m.Cmode("pink" as RecoMode);
        }}></input>
        <label htmlFor="button-Pink" style={{ display: 'inline-block', background: 'rgb(180,0,97)', color: 'white', border: '2px solid rgb(150,150,150)', padding: '0.1em 0.2em' }}>Pink</label>
      </form>
      <form>
        <input className="bold" id="input-font-family" type="text" name="font" value={styles.fontFamily} style={{fontFamily:'inherit', fontSize:'1.2em', width:'103px', height:'23px', textAlign:'center'}} onChange={(e) => {
          m.CfontFamily(e.target.value);
        }}></input>
      </form>
      <form>
        <button type="button" onClick={() => m.CfontSize(-0.02)} style={{ fontSize: '1em' }}>A</button>
        <button type="button" onClick={() => m.CfontSize(0.02)} style={{ fontSize: '1.4em' }}>A</button>
      </form>
      <form>
        <button type="button" onClick={() => m.ClineHeight(-0.1)} style={{ fontSize: '1em' }}>=</button>
        <button type="button" onClick={() => m.ClineHeight(0.1)} style={{ fontSize: '1.6em' }}>=</button>
      </form>
      <DeviceInfo styles={styles}></DeviceInfo>
    </div>
  );
}

function DeviceInfo({ styles }) {
  return (
    <div className="deviceInfo">
      {`Mode: ${styles.mode}; Font: ${styles.fontFamily}; font-size: ${(styles.fontSize).toFixed(2)}em; line-height: ${(styles.lineHeight).toFixed(1)};`}
      <br />
      {`width: ${styles.innerWidth}, height: ${styles.innerHeight}`}
    </div>
  );
}
